<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>{{ isEdit ? "編輯橫幅" : "新增橫幅" }}</h6>
          </div>
          <div class="card-body">
            <form @submit.prevent="handleSubmit">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="title" class="form-control-label">標題</label>
                    <input
                      class="form-control"
                      type="text"
                      id="title"
                      v-model="form.title"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="link_url" class="form-control-label"
                      >連結 URL</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      id="link_url"
                      v-model="form.link_url"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="subtitle" class="form-control-label"
                      >副標題</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      id="subtitle"
                      v-model="form.subtitle"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="media_type" class="form-control-label"
                      >媒體類型</label
                    >
                    <select
                      class="form-control"
                      id="media_type"
                      v-model="form.media_type"
                    >
                      <option value="image">圖片</option>
                      <option value="video">影片 (背景播放)</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="image" class="form-control-label"
                      >桌面版媒體 (圖片/影片)</label
                    >
                    <input
                      class="form-control"
                      type="file"
                      id="image"
                      @change="handleFileUpload($event, 'desktop')"
                      accept="image/*,video/*,.heic,.heif"
                    />
                    <div v-if="previewUrl" class="mt-2">
                      <video
                        v-if="isVideo(previewUrl)"
                        :src="previewUrl"
                        class="img-thumbnail"
                        style="max-height: 150px"
                        controls
                      ></video>
                      <img
                        v-else
                        :src="previewUrl"
                        class="img-thumbnail"
                        style="max-height: 150px"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="mobile_image" class="form-control-label"
                      >手機版媒體 (圖片/影片 - 選填)</label
                    >
                    <input
                      class="form-control"
                      type="file"
                      id="mobile_image"
                      @change="handleFileUpload($event, 'mobile')"
                      accept="image/*,video/*,.heic,.heif"
                    />
                    <small class="form-text text-muted"
                      >若未上傳，手機版將顯示桌面版媒體。</small
                    >
                    <div v-if="previewMobileUrl" class="mt-2">
                      <video
                        v-if="
                          form.media_type === 'video' &&
                          isVideo(previewMobileUrl)
                        "
                        :src="previewMobileUrl"
                        class="img-thumbnail"
                        style="max-height: 150px"
                        controls
                      ></video>
                      <img
                        v-else
                        :src="previewMobileUrl"
                        class="img-thumbnail"
                        style="max-height: 150px"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label for="sort_order" class="form-control-label"
                      >排序</label
                    >
                    <input
                      class="form-control"
                      type="number"
                      id="sort_order"
                      v-model="form.sort_order"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="form-control-label">狀態</label>
                    <div class="form-check form-switch mt-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="isActive"
                        v-model="form.is_active"
                      />
                      <label class="form-check-label" for="isActive"
                        >啟用</label
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-4">
                <button
                  type="button"
                  class="btn btn-light me-2"
                  @click="$router.push('/banners')"
                >
                  取消
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="loading"
                >
                  {{ loading ? "儲存中..." : "儲存" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import Swal from "sweetalert2";
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted, computed } from "vue";

export default {
  name: "HeroBannerForm",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const loading = ref(false);
    const form = ref({
      title: "",
      subtitle: "",
      link_url: "",
      sort_order: 0,
      is_active: true,

      media_url: "",
      mobile_media_url: "",
      media_type: "image",
    });
    const previewUrl = ref(null);
    const previewMobileUrl = ref(null);

    const isEdit = computed(() => route.params.id !== undefined);

    const fetchBanner = async (id) => {
      try {
        const response = await request.get(`/api/admin/hero-banners/${id}`);
        const data = response.data.data;
        form.value = {
          title: data.title,
          subtitle: data.subtitle,
          link_url: data.link_url,
          sort_order: data.sort_order,
          is_active: !!data.is_active,
          media_type: data.media_type || "image",
        };
        if (data.media_url) {
          form.value.media_url = data.media_url;
          previewUrl.value = data.media_url;
        }
        if (data.mobile_media_url) {
          form.value.mobile_media_url = data.mobile_media_url;
          previewMobileUrl.value = data.mobile_media_url;
        }
      } catch (error) {
        console.error("Failed to fetch banner", error);
        Swal.fire("錯誤", "載入失敗", "error");
      }
    };

    const handleFileUpload = async (event, type = "desktop") => {
      const file = event.target.files[0];
      if (file) {
        try {
          const formData = new FormData();
          formData.append("file", file);
          const response = await request.post("/api/admin/upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          if (response.data.success) {
            if (type === "mobile") {
              form.value.mobile_media_url = response.data.url;
              previewMobileUrl.value = response.data.url;
            } else {
              form.value.media_url = response.data.url;
              previewUrl.value = response.data.url;
            }
          } else {
            Swal.fire("錯誤", "上傳失敗", "error");
          }
        } catch (error) {
          console.error("Upload failed", error);
          Swal.fire("錯誤", "上傳失敗", "error");
        }
      }
    };

    const isVideo = (url) => {
      if (!url) return false;
      const extension = url.split(".").pop().toLowerCase();
      return ["mp4", "webm", "ogg", "mov"].includes(extension);
    };

    const handleSubmit = async () => {
      loading.value = true;
      try {
        const data = {
          title: form.value.title,
          subtitle: form.value.subtitle,
          link_url: form.value.link_url,
          sort_order: form.value.sort_order,
          is_active: form.value.is_active,

          media_url: form.value.media_url,
          mobile_media_url: form.value.mobile_media_url,
          media_type: form.value.media_type,
        };

        if (isEdit.value) {
          await request.put(`/api/admin/hero-banners/${route.params.id}`, data);
        } else {
          await request.post("/api/admin/hero-banners", data);
        }

        router.push("/banners");
      } catch (error) {
        console.error("Failed to save banner", error);
        Swal.fire("錯誤", error.response?.data?.message || "儲存失敗", "error");
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      if (isEdit.value) {
        fetchBanner(route.params.id);
      }
    });

    return {
      form,
      loading,
      isEdit,

      previewUrl,
      previewMobileUrl,
      handleSubmit,
      handleFileUpload,
      isVideo,
    };
  },
};
</script>
